export default __webpack_public_path__ + "static/media/rabbit8.516e1243.gif";